<div class="maintenance-text text-left pl-2 text-md">
  <!--
    Content intentionally empty; filled per maintenance announcement,
    shown via the backend showMaintenanceInfo flag.
  -->
</div>
